/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const StartedTransactionParser = /* #__PURE__ */ parsers.object([
    ['paymentUrl', codecString, 'payment_url'],
    ['transactionId', codecString, 'transaction_id'],
]);
export class StartedTransaction extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return StartedTransactionParser.decode(input).map(res => new StartedTransaction(res));
    }
    static unsafeDecode(input) {
        return StartedTransaction.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return StartedTransactionParser.encode(data);
    }
    static schema() {
        return StartedTransactionParser.schema();
    }
}
